import { Injectable } from '@angular/core';
import { EntityService, HttpClient } from '@elotech/angular-common';
import { Observable } from 'rxjs';

@Injectable()
export class UsuarioService extends EntityService<any> {

  constructor(public httpClient: HttpClient) {
    super(httpClient);
    this.resource = '/api/usuarios';
  }

  findOneByCpf(cpf: string): Observable<any> {
    return this.httpClient.get({
      resource: `${this.resource}/cpf/${cpf}`,
    });
  }

  getAllRolesUser(idKeycloak: string): Observable<any> {
    return this.httpClient.get({
      resource: `${this.resource}/usuario/${idKeycloak}/roles`,
    });
  }

  completarCadastro(usuario: any): Observable<any> {
    return this.httpClient.post({
      resource: `${this.resource}`,
      body: usuario,
    });
  }

  public findUserInfo() {
    return this.httpClient.get({
      resource: `${this.resource}/userInfo`,
      disableSpinner: true
    });
  }

  public hasacessoBloqueadoDesligamentoOuFeriasOuAfastado(cpf: string): Observable<any> {
    return this.httpClient.get({
      resource: `${this.resource}/acessoBloqueadoDesligamentoOuFeriasOuAfastado/${cpf}`,
      disableSpinner: true
    });
  }
}
